import { Grid, Modal } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  BasicTable,
  Button,
  TextField,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';

import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import React, { useState } from 'react';
import componentConstants from '../../../core-utils/messages/componentConstants';
import ReportCreateNewLabelField from '../../atoms/ReportCreateNewLabelField';
import Dropdown from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/Dropdown';
import { commonDropDownProps } from '../../atoms/ReportsCohortItem';
import { Columns } from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/BasicTable';

export const cellStyles4 = {
  color: patientAccessTheme.palette.text.mediumemphasis,
  fontSize: '14px',
  fontWeight: 400,
};

export interface AssignCareNavModalProps {
  open: boolean;
  handleClose: () => any;
  handleSave: () => any;
  isSaveButtonDisabled: boolean;
  columns: Columns[];
  rowsData: any;
  isReplaceModal?: boolean;
  assignCareNavState: [any, React.Dispatch<React.SetStateAction<any>>];
  careNavFieldsData: any;
  isCareNavigator?: boolean;
  handleSelfAssign?: () => any;
}

const AssignCareNavModal: React.FC<AssignCareNavModalProps> = ({
  open,
  handleClose,
  handleSave,
  isSaveButtonDisabled,
  columns,
  rowsData,
  isReplaceModal,
  assignCareNavState,
  careNavFieldsData,
  isCareNavigator,
  handleSelfAssign,
}) => {
  const useStyles = makeStyles()({
    modal: {
      width: '553px',
      height: isReplaceModal ? '484px' : '400px',
      background: patientAccessTheme.palette.status.white,
      borderRadius: '8px',
      padding: '24px 24px 24px 32px',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      flexDirection: 'column',
    },
    inputFieldsGrid: {
      width: '490px',
      marginTop: '20px',
      background: '#FBFBFE',
      padding: '16px 20px',
      borderRadius: '8px',
    },
    selectFields: {
      display: 'flex',
      flexDirection: 'row',
    },
    cancelButton: {
      padding: '9px 16px',
      width: '102px',
      height: '36px',
      border: '1px solid ' + patientAccessTheme.palette.primary[500],
      borderRadius: '4px',
      textTransform: 'none',
      fontSize: '12px',
      lineHeight: '12px',
      fontWeight: 500,
    },
    saveButton: {
      padding: '9px 16px',
      width: '158px',
      height: '36px',
      border:
        '1px solid ' + isSaveButtonDisabled
          ? patientAccessTheme.palette.grey[500]
          : patientAccessTheme.palette.primary[500],
      borderRadius: '4px',
      textTransform: 'none',
      fontSize: '12px',
      lineHeight: '12px',
      fontWeight: 500,
    },
  });
  const { classes } = useStyles();
  const constants = componentConstants.ORGANISMS.CARE_NAV_MODALS.ASSIGN_MODAL;

  const [assignData, setAssignData] = assignCareNavState;
  const [careNavigators, setCareNavigators] = useState<any[]>([]);

  return (
    <Modal open={open} onClose={handleClose}>
      <Grid container className={classes.modal}>
        <Grid>
          <Typography
            fontSize="18px"
            lineHeight="26px"
            fontType="medium"
            textColor={patientAccessTheme.palette.text.highemphasis}
            margin="4px 0px 20px 0px"
          >
            {isReplaceModal ? constants.REPLACE_TITLE : constants.ASSIGN_TITLE}
          </Typography>
        </Grid>

        <Grid>
          <BasicTable
            width={'490px'}
            displayType={'box'}
            columns={columns}
            rowsData={rowsData}
            headerTextColor={patientAccessTheme.palette.status.white}
            headerColor={patientAccessTheme.palette.grey[700]}
            borderRadius="4px"
          />
        </Grid>

        <Grid container className={classes.inputFieldsGrid}>
          <Grid className={classes.selectFields}>
            <Grid style={{ marginRight: '30px' }}>
              <ReportCreateNewLabelField
                label={constants.SELECT_ROLE}
                component={
                  <Dropdown
                    label="Select"
                    dropDownOptions={constants.roleOptions}
                    dropDownValues={constants.roleValues}
                    value={assignData.cn_role}
                    handleChange={(e) => {
                      const role = e.target.value as string;
                      setAssignData((prev: any) => ({
                        ...prev,
                        cn_role: role,
                        cn_id: '',
                        cn_name: '',
                      }));
                      setCareNavigators(careNavFieldsData?.[role] ?? []);
                    }}
                    selectStyles={{
                      ...commonDropDownProps.selectStyles,
                      width: '200px',
                    }}
                    labelTop="10px"
                  />
                }
              />
            </Grid>
            <Grid>
              <ReportCreateNewLabelField
                label={constants.SELECT_CARE_NAV}
                component={
                  <Dropdown
                    label="Select"
                    dropDownOptions={
                      careNavigators?.map((item: any) => item.name) ?? []
                    }
                    dropDownValues={
                      careNavigators?.map((item: any) => item.id) ?? []
                    }
                    value={assignData.cn_id}
                    setValue={undefined}
                    handleChange={(e: any) => {
                      const careNav = careNavigators.find(
                        (item) => item.id === e.target.value,
                      );
                      setAssignData((prev: any) => ({
                        ...prev,
                        cn_id: careNav?.id,
                        cn_name: careNav?.name,
                      }));
                    }}
                    selectStyles={{
                      ...commonDropDownProps.selectStyles,
                      width: '200px',
                    }}
                    labelTop="10px"
                    isTooltip={true}
                    tooltipValues={[]}
                  />
                }
              />
            </Grid>
          </Grid>

          {isReplaceModal && (
            <Grid>
              <ReportCreateNewLabelField
                label={constants.ADD_NOTE}
                component={
                  <TextField
                    value={assignData.cn_assign_note}
                    minRows={2}
                    multiline={true}
                    error={false}
                    placeholder={'Type here...'}
                    height="55px"
                    width="430px"
                    inputPropsStyle={{
                      padding: '16px',
                    }}
                    onChange={(e: any) => {
                      setAssignData((prev: any) => ({
                        ...prev,
                        cn_assign_note: e.target.value,
                      }));
                    }}
                  />
                }
              />
            </Grid>
          )}
        </Grid>

        <Grid
          container
          style={{
            position: 'absolute',
            bottom: 0,
            margin: isCareNavigator ? '20px 0px' : '0 0 20px 190px',
            gap: '10px',
          }}
          sx={{
            alignItems: 'center',
          }}
        >
          <Grid>
            <Button
              label={constants.CANCEL}
              variant="outlined"
              className={classes.cancelButton}
              onClick={handleClose}
            />
          </Grid>
          {isCareNavigator && (
            <Grid>
              <Button
                width="185px"
                label={constants.SELF_ASSIGN}
                variant="contained"
                className={classes.saveButton}
                disabled={!isCareNavigator}
                onClick={() => {
                  handleSelfAssign && handleSelfAssign();
                }}
              />
            </Grid>
          )}
          <Grid>
            <Button
              width="158px"
              label={isReplaceModal ? constants.UPDATE : constants.SUBMIT}
              variant="contained"
              className={classes.saveButton}
              disabled={isSaveButtonDisabled}
              onClick={() => {
                handleSave && handleSave();
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};
export default AssignCareNavModal;
